import { defineStore } from 'pinia';
import { shallowRef } from 'vue';
import { IInterconnector } from '@/interfaces/powerMarkets/maps/interconnectors/IInterconnector.ts';
import { mapApi } from '@/api/powerMarkets/mapApi.ts';

const useMapStore = defineStore('mapStore', () => {
    const interconnectors = shallowRef<Array<IInterconnector>>([]);

    function updateInterconnectors (val: Array<IInterconnector>): void {
        interconnectors.value = val;
    }

    async function fetchInterconnectors (): Promise<void> {
        return mapApi.getInterconnectors().then((response) => {
            // TODO: revert this once the API is ready
            // updateInterconnectors(response.data);
            updateInterconnectors(response.data);
        });
    }

    return {
        interconnectors,
        fetchInterconnectors,
        updateInterconnectors,
    };
});

export {
    useMapStore,
};
